import { TAO_KOE, EN_KO } from './../libs/';

class UsercentricsPopup {
	constructor() {
		window.addEventListener( 'UC_UI_VIEW_CHANGED', ( ev ) => {
			if ( [ 'FIRST_LAYER', 'SECOND_LAYER' ].includes( ev.detail.view ) ) {
				//EN_KO.functions.disablePageScroll();
			} else {
				//requestAnimationFrame( () => EN_KO.functions.enablePageScroll() );
			}
		} );

		window.addEventListener( 'UC_UI_CMP_EVENT', ( ev ) => {
			if ( ev.detail.type === 'ACCEPT_ALL' || ev.detail.type === 'DENY_ALL' || ev.detail.type === 'SAVE' ) {
				window.dispatchEvent( new CustomEvent( 'triggered_cmp_event.tao' ) );
			}
		} );

		if ( EN_KO.functions.isMobileApp() ) {
			window.addEventListener( 'UC_GENERAL', ( ev ) => {
				if ( [ 'onInitialPageLoad', 'onSessionRestored' ].includes( ev.detail.action ) ) {
					// Do nothing.
					return;
				}

				if ( 'ReactNativeWebView' in window ) {
					window.ReactNativeWebView.postMessage( JSON.stringify( { 'type': ev.type, 'detail': ev.detail } ) );
				}
			} );
		}
	}

	async open() {
		return await window.UC_UI.showFirstLayer();
	}

	async close() {
		return await window.UC_UI.closeCMP();
	}

	static instance = null;

	static init( resolve ) {
		TAO_KOE.console.log( 'INIT USERCENTRICS POPUP' );

		//This only concerns us if cookies are enabled.
		if ( ! navigator.cookieEnabled ) {
			// Resolve successfully.
			return resolve();
		}

		UsercentricsPopup.instance ??= new UsercentricsPopup();
		return Promise.race( [
			new Promise( ( res1 ) => {
				window.addEventListener( 'triggered_cmp_event.tao', () => res1(), { once: true } );
			} ),
			new Promise( ( res2 ) => {
				// Fire as soon as UserCentrics finished loading.´
				return UsercentricsPopup.ready().then( () => {
					if ( window.UC_UI.isConsentRequired() ) {
						UsercentricsPopup.instance.open();
					} else {
						res2();
					}
				} );
			} ),
		] ).then( () => resolve() );
	}

	static ready() {
		if ( window.UC_UI && window.UC_UI.isInitialized() ) {
			return Promise.resolve( true );
		}

		return new Promise( ( resolve ) => window.addEventListener( 'UC_UI_INITIALIZED', () => resolve( true ) ) );
	}

	static initTriggers = function() {
		const triggerEls = document.querySelectorAll( 'a[href="#cookieeinstellungen"]' );
		if ( triggerEls ) {
			triggerEls.forEach( ( triggerEl ) => {
				triggerEl.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					if ( window.UC_UI && window.UC_UI.isInitialized() ) {
						window.UC_UI.showSecondLayer();
					}
				} );
			} );
		}

		const triggerFitanalyticsEls = document.querySelectorAll( '.js-usercentrics-accept-fitanalytics' );
		triggerFitanalyticsEls.forEach( ( button ) => button.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			if ( window.UC_UI && window.UC_UI.isInitialized() ) {
				window.UC_UI.acceptService( 'dJuNHeMq3' ).then( () => {
					TAO_KOE.close_popup( '#popup_customconsent_fitanalytics', 'Fitanalytics' );
				} );
			}
		} ) );

		const triggerSmartfitEls = document.querySelectorAll( '.js-usercentrics-accept-smartfit' );
		triggerSmartfitEls.forEach( ( button ) => button.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			if ( window.UC_UI && window.UC_UI.isInitialized() ) {
				window.UC_UI.acceptService( 'EiZwMcuSR-mQ0e' ).then( () => {
					TAO_KOE.close_popup( '#popup_customconsent_smartfit', 'SmartFit' );
				} );
			}
		} ) );

		const triggerConsentEls = document.querySelectorAll( '.js-usercentrics-accept-consent' );
		triggerConsentEls.forEach( ( buttonEl ) => buttonEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			if ( window.UC_UI && window.UC_UI.isInitialized() ) {
				const service = window.UC_UI.getServicesBaseInfo().find( ( { name } ) => buttonEl.dataset.usercentricsService === name );
				if ( service ) {
					window.UC_UI.acceptService( service.id ).then( () => {
						const popupEl = buttonEl.closest( '.mdl_popup' );
						if ( popupEl ) {
							TAO_KOE.close_popup( popupEl, service.name );
						}
					} );
				}
			}
		} ) );
	};
}

// Init.
TAO_KOE.chainReady( 'usercentrics.js', ( resolve ) => UsercentricsPopup.init( resolve ), 20 );
TAO_KOE.ready( 'usercentrics-triggers.js', () => UsercentricsPopup.initTriggers() );

// Expose.
TAO_KOE.UsercentricsPopup = UsercentricsPopup;
export default UsercentricsPopup;
